function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useField, useFormikContext } from 'formik';
import React from 'react';
import { FormGroup, Row, Col, Button } from 'reactstrap';
import Media from "../common/media";
import Uploader from "../common/upload";
import { Error, Label } from "./";
import { t } from "../../services/translator";
export default (function (_ref) {
  var name = _ref.name,
      label = _ref.label,
      type = _ref.type,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size,
      _ref$resource = _ref.resource,
      resource = _ref$resource === void 0 ? null : _ref$resource,
      _ref$groupTag = _ref.groupTag,
      groupTag = _ref$groupTag === void 0 ? FormGroup : _ref$groupTag,
      _ref$labelTag = _ref.labelTag,
      labelTag = _ref$labelTag === void 0 ? Label : _ref$labelTag,
      _ref$errorTag = _ref.errorTag,
      errorTag = _ref$errorTag === void 0 ? Error : _ref$errorTag,
      _ref$groupProps = _ref.groupProps,
      groupProps = _ref$groupProps === void 0 ? {} : _ref$groupProps,
      _ref$labelProps = _ref.labelProps,
      labelProps = _ref$labelProps === void 0 ? {} : _ref$labelProps,
      _ref$errorProps = _ref.errorProps,
      errorProps = _ref$errorProps === void 0 ? {} : _ref$errorProps,
      props = _objectWithoutProperties(_ref, ["name", "label", "type", "size", "resource", "groupTag", "labelTag", "errorTag", "groupProps", "labelProps", "errorProps"]);

  var _useField = useField({
    name: name
  }),
      _useField2 = _slicedToArray(_useField, 3),
      field = _useField2[0],
      meta = _useField2[1],
      helper = _useField2[2];

  var _useFormikContext = useFormikContext(),
      submitCount = _useFormikContext.submitCount;

  var GroupTag = groupTag;
  var LabelTag = labelTag;
  var ErrorTag = errorTag;
  label = labelProps.text || label;

  if (label === undefined) {
    label = name;
  }

  var handleFileChange = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(media) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return media;

            case 2:
              helper.setValue(media);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleFileChange(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement(GroupTag, groupProps, label && /*#__PURE__*/React.createElement(LabelTag, _extends({
    name: name,
    size: size
  }, labelProps), label), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: "3",
    className: "col-3"
  }, field.value && /*#__PURE__*/React.createElement(Media, {
    data: field.value,
    className: "media-input"
  })), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Uploader, {
    component: function component(_ref3) {
      var onClick = _ref3.onClick;
      return /*#__PURE__*/React.createElement(Button, {
        type: "button",
        onClick: onClick,
        color: "default"
      }, t('upload'));
    },
    multiple: props.multiple,
    onChange: handleFileChange,
    resource: resource,
    name: name,
    invalid: (meta.touched || submitCount > 0) && meta.error !== undefined
  }))), /*#__PURE__*/React.createElement(ErrorTag, _extends({
    name: name
  }, errorProps)));
});